export const email_regex = /[ğüşöçıİĞÜŞÖÇ]/;

export const isnet_mail_regex = /^((?![ğüşöçıİĞÜŞÖÇ]).)*@(is\.net\.tr)$/;

export const name_regex = /^[a-zA-ZğüşöçıIİĞÜŞÖÇ\s]*$/;

// export const password_regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const password_regex =
  /(?=[A-Za-z0-9@#$%^&+!?.=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+!.?=])(?=.{8,}).*$/;

export const ip_address_regex =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const url_regex =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export const freeMailRegex =
  /\w+([-+.]\w+)*@(yahoo|outlook|gmail|hotmail|redmail|next|Next|Next)/;

export const uuid_regex =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export const text_regex = /[^A-Za-z0-9]+/;
